/* eslint-disable react/prop-types */
import { Button, FormControlLabel, Switch } from "@material-ui/core"
import BaseDialog from "components/common/BaseDialog"
import React, { useState } from "react"

function InvoicePrintSettingDialog({ open, onClose }) {
  const [withRefQuot, setWithRefQuot] = useState(false)
  const [showPercentage, setShowPercentage] = useState(false)
  const [showBreakdown, setShowBreakdown] = useState(false)
  const [withPackingList, setWithPackingList] = useState(false)

  return (
    <BaseDialog
      open={open}
      onClose={() => onClose({})}
      hideCancelButton
      hideConfirmButton
    >
      <div style={{ display: "flex", flexDirection: "column" }}>
        <FormControlLabel
          control={
            <Switch
              checked={withRefQuot}
              onChange={(e) => setWithRefQuot(e.target.checked)}
              color="primary"
            />
          }
          label="With Ref Quot"
        />
        <FormControlLabel
          control={
            <Switch
              checked={showPercentage}
              onChange={(e) => setShowPercentage(e.target.checked)}
              color="primary"
            />
          }
          label="With Payment Percentage"
        />

        <FormControlLabel
          control={
            <Switch
              checked={showBreakdown}
              onChange={(e) => setShowBreakdown(e.target.checked)}
              color="primary"
            />
          }
          label="Show Sales Quot Breakdown"
        />
        <FormControlLabel
          control={
            <Switch
              checked={withPackingList}
              onChange={(e) => setWithPackingList(e.target.checked)}
              color="primary"
            />
          }
          label="With Packing List"
        />

        <Button
          color="primary"
          variant="contained"
          onClick={() => {
            onClose({
              withPaymentPercentage: showPercentage,
              withRefQuot,
              showBreakdown,
              withPackingList,
            })
          }}
        >
          Print
        </Button>
      </div>
    </BaseDialog>
  )
}

export default InvoicePrintSettingDialog
